import { render, staticRenderFns } from "./SettingsWin.vue?vue&type=template&id=ba99fe08&scoped=true"
import script from "./SettingsWin.vue?vue&type=script&lang=js"
export * from "./SettingsWin.vue?vue&type=script&lang=js"
import style0 from "./SettingsWin.vue?vue&type=style&index=0&id=ba99fe08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba99fe08",
  null
  
)

export default component.exports